import { apiErrors, apiMethodnames } from '../constants/common';
import handleIsRecognizedPreference from '../handlers/handle-is-recognized-preference';
import pushEvent, { promiseTimer, pushIsRecognizedEvent } from '../helpers/log-batch';
import OrchCustomData from '../helpers/orch-custom-data';
import promiseTimeout from '../helpers/promise-timeout';

/**
 * isRecognizedMul is used to call isRecognized api parallel to all SRC sdks
 */
const isRecognizedMul = () => {
  const timeOutError = network => ({
    [network]: {
      error: apiErrors.TIME_OUT
    }
  });
  const promiseRejectError = network => ({
    [network]: {
      error: apiErrors.REJECT
    }
  });

  const promiseWrapper = function(instance, instanceName, data, method) {
    return new Promise(resolve => {
      if (instance === null || instance === undefined) {
        const resultData = {
          [instanceName]: {
            error: apiErrors.NO_INSTANCE
          }
        };
        resolve(resultData);
      }

      const startTime = Date.now();
      promiseTimer(instance, method, data, instanceName, pushIsRecognizedEvent)
        .then(res => {
          const resultData = {
            [instanceName]: {
              idTokens: res.idTokens,
              recognized: res.recognized
            }
          };
          resolve(resultData);
        })
        .catch(error => {
          const resultData = {
            [instanceName]: error
          };

          const stepErr = `ORCH_IS_RECOGNIZED_${instanceName}_API_ERROR_RESPONSE`;
          const endTime = Date.now();
          pushEvent(
            stepErr,
            OrchCustomData.srcInitiatorId[instanceName],
            startTime,
            endTime,
            error
          );
          resolve(resultData);
        });
    });
  };

  const { IS_RECOGNIZED } = apiMethodnames;
  const promiseArr = [];
  const loadedSdk = OrchCustomData.srcSdks.loadedSdk;

  for (const key in loadedSdk) {
    const sdkInstance = loadedSdk[key];
    const sdkPromise = promiseTimeout(
      promiseWrapper(sdkInstance, key, {}, IS_RECOGNIZED),
      timeOutError(key),
      promiseRejectError(key)
    );
    promiseArr.push(sdkPromise);
  }

  Promise.all(promiseArr).then(values => {
    for (const value of values) {
      OrchCustomData.setRecognized(value);
    }
    handleIsRecognizedPreference();
  });
};

export default isRecognizedMul;
